import { render } from "./AiImportShowComponent.vue?vue&type=template&id=3778b1ae&scoped=true"
import script from "./AiImportShowComponent.vue?vue&type=script&lang=js"
export * from "./AiImportShowComponent.vue?vue&type=script&lang=js"

import "./AiImportShowComponent.vue?vue&type=style&index=0&id=3778b1ae&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3778b1ae"],['__file',"resources/js/components/admin/products/ai-import/AiImportShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3778b1ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3778b1ae', __exports__)) {
    api.reload('3778b1ae', __exports__)
  }
  
  module.hot.accept("./AiImportShowComponent.vue?vue&type=template&id=3778b1ae&scoped=true", () => {
    api.rerender('3778b1ae', render)
  })

}


export default __exports__